<!-- components/LanguageSwitcher.vue -->
<script setup lang="ts">
const { locale, setLocale } = useI18n()

function switchTo(lang: any) {
  setLocale(lang)
}
</script>

<template>
  <div class="flex gap-2">
    <button @click="switchTo('en')" :class="{ 'font-bold': locale === 'en' }">🇺🇸 EN</button>
    <button @click="switchTo('es')" :class="{ 'font-bold': locale === 'es' }">🇲🇽 ES</button>
    <button @click="switchTo('zh-cn')" :class="{ 'font-bold': locale === 'zh-cn' }">🇨🇳 中文</button>
  </div>
</template>